export default __webpack_public_path__ + "static/media/electrician.2527d435.jpg";